module.exports = __webpack_public_path__ + "static/media/insulation_lcs_60yd_y.156b27da.csv";